import React from "react";
import {createPortal} from "react-dom";
import useMedia from "../hooks/useMedia";

const CompareWishlistContainer = ({renderModelViewerToggle,renderWishlistToggle,templateContext}) => {
  const isDesktop = useMedia("(min-width: 768px)");
  const desktopContainer = document.querySelector("#pdp-product-gallery");

  const content = (
    <div id="compare-wishlist-container" className="pdp-hero__cw">
      {(templateContext.showWishlistBtn && !templateContext.showModelViewerBtn) && (
        <div className="pdp-hero__cw-section pdp-hero__cw-section--left">
        </div>
      )}
      {(templateContext.showModelViewerBtn) && (
        <div className="pdp-hero__cw-section pdp-hero__cw-section--left">
          {renderModelViewerToggle()}
        </div>
      )}
      {(!templateContext.showWishlistBtn && templateContext.showModelViewerBtn) && (
        <div className="pdp-hero__cw-section pdp-hero__cw-section--right">
        </div>
      )}
      {(templateContext.showWishlistBtn) && (
        <div className="pdp-hero__cw-section pdp-hero__cw-section--right">
          {renderWishlistToggle()}
        </div>
      )}
    </div>
  );

  return isDesktop
    ? createPortal(content, desktopContainer)
    : content;

};

export default CompareWishlistContainer;
